import { render, staticRenderFns } from "./autocomplete-team.vue?vue&type=template&id=678c1b0c&scoped=true&lang=pug&"
import script from "./autocomplete-team.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-team.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c1b0c",
  null
  
)

export default component.exports